import React, { useContext } from 'react'
import { YearSelect } from './YearSelect'
import { SeasonContext } from '../../../../Context'
import { SeasonType } from '../../../../Routing/urls'
import { SeasonTypeRow } from './SeasonTypeRow'
import { SelectorCon } from '../Selectors.styles'
import {
  SEASON_SELECTOR_TYPES,
  SeasonSelectorType,
} from '../../../../Constant/season'
import { SEASON_SEGMENT_NAMES } from '../../../../Utils'

type SeasonSelectorProps = {
  seasonSelectorType?: SeasonSelectorType
  color?: string
  allYears?: number[] | undefined
  isEventsSelect?: boolean
  disableChampSeries?: boolean
}

export const SeasonSelector: React.FC<React.PropsWithChildren<SeasonSelectorProps>> = ({
  seasonSelectorType = SEASON_SELECTOR_TYPES.MAIN,
  disableChampSeries = false,
}) => {
  const { onSeasonDropdownChange, seasonSelect } = useContext(SeasonContext)!

  const onChangeYear = (year: number) => {
    onSeasonDropdownChange(
      {
        seasonType: SEASON_SEGMENT_NAMES.regular,
        year: year,
      },
      seasonSelectorType
    )
  }

  const onChangeType = (seasonType: SeasonType) => {
    onSeasonDropdownChange(
      {
        seasonType: seasonType,
        year: seasonSelect[seasonSelectorType].year,
      },
      seasonSelectorType
    )
  }

  return (
    <SelectorCon>
      <YearSelect
        current={seasonSelect[seasonSelectorType].year}
        onChangeYear={onChangeYear}
        seasonSelectorType={seasonSelectorType}
      />
      <SeasonTypeRow
        seasonType={seasonSelect[seasonSelectorType].seasonType}
        disablePostSeason={seasonSelect[seasonSelectorType].year === 2020} //2020 only year without postseason
        disableChampSeries={
          seasonSelect[seasonSelectorType].year < 2023 || disableChampSeries
        }
        onSelectSeasonType={onChangeType}
      />
    </SelectorCon>
  )
}
